import React from 'react';
import Navigation from '../components/Navigation';
import ContributionSection from '../components/ContributionSection';

const PaymentPage: React.FC = () => {
  return (
    <>
      <Navigation />
      <main style={{ paddingTop: '80px' }}>
        <ContributionSection />
      </main>
      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-section">
              <h4>World Conserve</h4>
              <p>Restaurando los bosques de Colombia, un árbol a la vez.</p>
            </div>
            <div className="footer-section">
              <h4>Enlaces</h4>
              <ul>
                <li><a href="/">Inicio</a></li>
                <li><a href="/#about">Acerca de</a></li>
                <li><a href="/plant-trees">Plantar Árboles</a></li>
                <li><a href="/customer-portal">Mis Árboles</a></li>
              </ul>
            </div>
            <div className="footer-section">
              <h4>Contacto</h4>
              <p>Email: hello@worldconserve.org</p>
            </div>
          </div>
          <div className="footer-bottom">
            <p>&copy; 2024 World Conserve. Todos los derechos reservados.</p>
          </div>
        </div>
      </footer>
    </>
  );
};

export default PaymentPage;
